import axios from 'axios';
// import store from '../store';
import crud from "./crud";

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'kolektorkredit';
export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','collector_name','crewnik','noemail','ktp','crewaddr'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(baseurl, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'customer', 'collectability', 'collector_id', 'model_pinjaman', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'kolektor.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/importdtxls`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savebulk(arr) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savebulk`, arr);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    collectorActivity(nasabahkey){
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`${baseurl}/collector-activity/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    golongankolektor() {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`${baseurl}/golongan-kolektor`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}